import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientMypageListItemContent のスタイル
 */
export const hotlineClientMypageListItemContentStyle = tv({
    slots: {
        firstContent: ['flex flex-col lg:flex-row lg:items-center gap-8'],
        item: [
            'flex flex-col lg:flex-row lg:flex-nowrap lg:justify-between gap-8 lg:gap-16',
            'py-16',
            'border-b-0 border-x-0 border-t border-solid border-gray-200',
        ],
        list: ['px-16'],
        noDataButtonWrap: ['flex flex-col lg:flex-row gap-16'],
        noDataContent: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            'flex flex-col items-center justify-center gap-16',
            'p-16',
            'border-b-0 border-x-0 border-t border-solid border-gray-200',
        ],
        schedule: [
            'flex items-center justify-start flex-wrap',
            'w-full lg:w-[309px]',
            'p-8',
            'rounded-md',
            'bg-blue-gray-75',
        ],
        scheduleHead: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        scheduleValue: [textStyle({ color: 'base', isBold: true, size: 'md' })],
        secondContent: [
            'flex flex-col lg:flex-row lg:flex-nowrap items-center gap-16',
            'lg:flex-shrink-0',
        ],
    },
});
